

exports.__esModule = true;
exports.$xoOpenButtonRoute = undefined;

require('jquery');

require('angularPlaceHolderShim');

require('js/lib/index');

require('xo-tracking/dist/index');

var _index = require('squid/index');

require('./directive');

var $xoOpenButtonRoute = exports.$xoOpenButtonRoute = _index.$Route.extend('$xoOpenButtonRoute', {
    path: 'openButton',
    directive: 'xo-openbutton-page',
    auth: false,
    trackingData: {
        fptiState: 'openButton',
        templateName: 'openButton.dust',
        pageGoal: 'openButton page',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-openButton',
                'pagename2': '%::fullpage-openButton:wps:openbutton:',
                'version': 'member:%:'
            }
        },
        trackStateExit: true
    }
});

angular.value("$xoOpenButtonRoute", $xoOpenButtonRoute);
_index.$Route;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-openbutton/route.js
// module id = ./pages/xo-openbutton/route.js
// module chunks = 1